import { MouseEventHandler } from 'react';
import type { ModalData } from '..';

export interface CookiePreferencesFormValues {
  necessary: boolean;
  analytics: boolean;
}

export interface CookiePreferencesModalItem {
  id: string;
  title: string;
  content: string;
  name: 'necessary' | 'analytics';
}

export interface CookiePreferencesModalData {
  modal: ModalData;
  items: CookiePreferencesModalItem[];
  onAllowAllClick: MouseEventHandler;
  onSaveClick: MouseEventHandler;
}

export interface CookiePreferencesModalProps extends CookiePreferencesModalData {}
